import { Breakpoint } from 'antd';
import { RangePickerProps } from 'antd/es/date-picker';

import { Chart } from '@ant-design/charts';

import dayjs, { Dayjs } from 'dayjs';
import { IntlShape } from 'node_modules/@umijs/plugins/node_modules/react-intl/lib/react-intl';

import { CHART_EXPORT_WIDTH } from '@/constants';
import { ChartCallbacks, ChartData, ChartEvent, ChartLegend, FindChartsResponse } from '@/types';

export * from './clarity';
export * from './pickerFormat';
export * from './staticIntl';

export const getDaysBetween = (start: Dayjs, end: Dayjs) => {
  const range = [];
  let current = start;
  while (!current.isAfter(end)) {
    range.push(current);
    current = current.add(1, 'days');
  }
  return range;
};

export const formatDateTime = (intl: IntlShape, date: string): string => intl.formatDate(date, { day: '2-digit', hour: '2-digit', minute: '2-digit', month: '2-digit', year: 'numeric' });

export const formatDate = (intl: IntlShape, date: string): string => intl.formatDate(date, { day: '2-digit', month: '2-digit', year: 'numeric' });

export const formatTime = (intl: IntlShape, date: string): string => intl.formatDate(date, { hour: '2-digit', minute: '2-digit' });

export const formatDateTimeSecond = (intl: IntlShape, date: string): string => intl.formatDate(date, { day: '2-digit', hour: '2-digit', minute: '2-digit', month: '2-digit', second: '2-digit', year: 'numeric' });

export const isDateAfterToday: RangePickerProps['disabledDate'] = current => current > dayjs().endOf('day');

export const preserveLegend = (chartCallbacks: ChartCallbacks, legendRef: React.MutableRefObject<ChartLegend>) => {
  chartCallbacks.on('legend:filter', ({ data: legendData, nativeEvent }: ChartEvent) => {
    if (!nativeEvent) return;
    legendRef.current = legendData;
  });

  chartCallbacks.on('afterrender', () => {
    chartCallbacks.emit('legend:filter', {
      data: legendRef.current,
    });
  });
};

export const getChartWidth = (size: undefined | { width: number }, exportStatus: boolean): number | undefined => {
  if (exportStatus) {
    return CHART_EXPORT_WIDTH;
  }
  return size ? size.width - 48 : undefined;
};

export const handleExportChart = (
  chartRef: React.MutableRefObject<Chart | null>,
  setExportStatus: React.Dispatch<React.SetStateAction<boolean>>,
  setSelectedCharts: React.Dispatch<React.SetStateAction<ChartData[]>>,
  filters: Omit<ChartData, 'chart'>,
) => {
  if (chartRef.current) {
    setExportStatus(true);
    setTimeout(() => {
      const chartDataUrl = chartRef.current?.toDataURL?.();
      setSelectedCharts(prev => ([...prev, { chart: chartDataUrl, ...filters }]));
    }, 1000);
    setTimeout(() => {
      setExportStatus(false);
    }, 2000);
  }
};

export const remapTimesChartData = (chartData: FindChartsResponse[], unit: string) => chartData.flatMap((item) => {
  const items = Object.keys(item).filter(key => key.includes(unit));

  return items.map(field => ({
    name: field.replace(unit, ''),
    timestamp: String(item.timestamp),
    value: item[field],
  }));
});

export const calculateImageCardWidth = (containerWidth: number | undefined, breakpoint: Breakpoint | undefined, gap: number) => {
  const columns: Record<Breakpoint, number> = { lg: 3, md: 3, sm: 2, xl: 4, xs: 1, xxl: 5 };
  return containerWidth && breakpoint ? (containerWidth / columns[breakpoint] - gap) : 200;
};
